import { Pipe, PipeTransform } from "@angular/core";
import { ResponseStatus } from "@handshake/core-types";

@Pipe({
  name: "responseStatus",
})
export class ResponseStatusPipe implements PipeTransform {
  transform(status: string): string {
    switch (status) {
      case ResponseStatus.ACCEPTED:
        return "Accepted";
      case ResponseStatus.REJECTED:
        return "Declined";
      default:
        return "";
    }
  }
}
